// configure foundation
require('intersection-observer');

import './foundation';
import './components';
